export const RBI_DOMAINS = [
  { key: "Governance & Board Oversight", title: "Governance & Board", controlCount: 8 },
  { key: "IT Risk Management", title: "IT Risk Management", controlCount: 6 },
  { key: "Asset Management", title: "Asset Management", controlCount: 7 },
  { key: "IAM & PAM", title: "IAM/PAM", controlCount: 12 },
  { key: "Network Security", title: "Network Security", controlCount: 14 },
  { key: "Endpoint Security", title: "Endpoint Security", controlCount: 9 },
  { key: "Vulnerability Management", title: "Vulnerability Management", controlCount: 8 },
  { key: "Application Security", title: "Application Security", controlCount: 11 },
  { key: "Data Security", title: "Data Security", controlCount: 10 },
  { key: "SOC & Logging", title: "SOC & Logging", controlCount: 12 },
  { key: "Incident Response", title: "Incident Response", controlCount: 7 },
  { key: "BCP/DR", title: "BCP/DR", controlCount: 8 },
  { key: "Third-Party Risk", title: "Third-Party Risk", controlCount: 9 },
  { key: "Fraud Prevention", title: "Fraud Prevention", controlCount: 6 },
  { key: "Channel Security", title: "Channel Security", controlCount: 8 },
];
export const RBI_CONTROLS = [
  {
    controlId: "RBI-GOV-01",
    controlDomain: "Governance & Board Oversight",
    controlRequirement:
      "Board-approved Information Security Policy covering all IT and cyber risks",
    minimumImplementationStandard:
      "Policy document approved by Board annually, covering all RBI-specified areas including cyber incidents, BCP, outsourcing",
    evidenceArtifacts:
      "Board minutes, Approved policy document, Version history",
    owner: "CISO / Board",
    frequency: "Annual",
    technologyEnablers: "GRC platforms (ServiceNow, Archer, MetricStream)",
    auditTestMethod: "Policy review, Board interview, Document inspection",
    commonGaps:
      "Policy exists but not Board-approved; Policy outdated >12 months",
    severity: "Critical",
    automationPotential: "Medium",
  },
  {
    controlId: "RBI-GOV-02",
    controlDomain: "Governance & Board Oversight",
    controlRequirement: "Designated CISO with direct Board reporting line",
    minimumImplementationStandard:
      "CISO appointed at senior management level with quarterly Board reporting mandate",
    evidenceArtifacts: "Org chart, CISO JD, Board presentation schedule",
    owner: "MD/CEO",
    frequency: "Ongoing",
    technologyEnablers: "-",
    auditTestMethod: "Org structure review, Interview",
    commonGaps: "CISO reports to CIO not Board; Part-time CISO",
    severity: "High",
    automationPotential: "Low",
  },
  {
    controlId: "RBI-GOV-03",
    controlDomain: "Governance & Board Oversight",
    controlRequirement: "IT Strategy Committee at Board level",
    minimumImplementationStandard:
      "Committee with defined charter, meeting quarterly minimum",
    evidenceArtifacts: "Committee charter, Meeting minutes, Attendance records",
    owner: "Board",
    frequency: "Quarterly",
    technologyEnablers: "Board management software",
    auditTestMethod: "Committee review",
    commonGaps: "No dedicated IT committee; Irregular meetings",
    severity: "High",
    automationPotential: "Low",
  },
  {
    controlId: "RBI-GOV-04",
    controlDomain: "Governance & Board Oversight",
    controlRequirement: "Cyber risk included in enterprise risk framework",
    minimumImplementationStandard:
      "Cyber risk register integrated with ERM, quantified using standard methodology",
    evidenceArtifacts:
      "Risk register, ERM integration evidence, Risk quantification",
    owner: "CRO/CISO",
    frequency: "Quarterly",
    technologyEnablers: "GRC, Risk platforms",
    auditTestMethod: "Risk register review",
    commonGaps: "Cyber risk siloed from ERM; No quantification",
    severity: "High",
    automationPotential: "Medium",
  },
  {
    controlId: "RBI-GOV-05",
    controlDomain: "Governance & Board Oversight",
    controlRequirement: "Annual information security budget allocation",
    minimumImplementationStandard:
      "Dedicated budget line for cyber security with Board approval",
    evidenceArtifacts: "Budget documents, Allocation evidence",
    owner: "CFO/CISO",
    frequency: "Annual",
    technologyEnablers: "-",
    auditTestMethod: "Budget review",
    commonGaps: "No dedicated budget; Underspend vs industry benchmark",
    severity: "Medium",
    automationPotential: "Low",
  },
  {
    controlId: "RBI-GOV-06",
    controlDomain: "Governance & Board Oversight",
    controlRequirement: "Cyber insurance coverage",
    minimumImplementationStandard:
      "Cyber insurance policy covering key risk scenarios",
    evidenceArtifacts: "Insurance policy, Coverage analysis",
    owner: "CFO/CISO",
    frequency: "Annual",
    technologyEnablers: "-",
    auditTestMethod: "Policy review",
    commonGaps: "No cyber insurance; Inadequate coverage",
    severity: "Medium",
    automationPotential: "Low",
  },
  {
    controlId: "RBI-GOV-07",
    controlDomain: "Governance & Board Oversight",
    controlRequirement: "Security awareness training for Board members",
    minimumImplementationStandard:
      "Annual cyber awareness session for Board on threats and responsibilities",
    evidenceArtifacts: "Training records, Presentation materials",
    owner: "CISO",
    frequency: "Annual",
    technologyEnablers: "LMS",
    auditTestMethod: "Training records review",
    commonGaps: "No Board training; Generic training",
    severity: "Medium",
    automationPotential: "Medium",
  },
  {
    controlId: "RBI-GOV-08",
    controlDomain: "Governance & Board Oversight",
    controlRequirement: "Independent security audit/assessment",
    minimumImplementationStandard:
      "Annual third-party security assessment with Board presentation of findings",
    evidenceArtifacts: "Audit reports, Remediation tracker",
    owner: "CISO",
    frequency: "Annual",
    technologyEnablers: "-",
    auditTestMethod: "Audit review",
    commonGaps: "No independent audit; Findings not tracked",
    severity: "High",
    automationPotential: "Low",
  },
  {
    controlId: "RBI-RISK-01",
    controlDomain: "IT Risk Management",
    controlRequirement: "IT risk assessment methodology",
    minimumImplementationStandard:
      "Documented methodology covering threat identification, vulnerability assessment, impact analysis",
    evidenceArtifacts: "Methodology document, Risk assessment reports",
    owner: "CISO/CRO",
    frequency: "Annual",
    technologyEnablers: "GRC platforms",
    auditTestMethod: "Methodology review",
    commonGaps: "Ad-hoc assessment; No documented methodology",
    severity: "High",
    automationPotential: "Medium",
  },
  {
    controlId: "RBI-RISK-02",
    controlDomain: "IT Risk Management",
    controlRequirement: "Asset-based risk assessment",
    minimumImplementationStandard:
      "Risk assessment covering all critical information assets",
    evidenceArtifacts: "Asset register, Risk assessment per asset",
    owner: "IT Head",
    frequency: "Annual",
    technologyEnablers: "CMDB, GRC",
    auditTestMethod: "Asset-risk mapping review",
    commonGaps: "Incomplete asset coverage; Generic risk ratings",
    severity: "High",
    automationPotential: "Medium",
  },
  {
    controlId: "RBI-RISK-03",
    controlDomain: "IT Risk Management",
    controlRequirement: "Risk treatment and acceptance process",
    minimumImplementationStandard:
      "Documented risk treatment options with defined acceptance authority levels",
    evidenceArtifacts: "Risk treatment register, Acceptance approvals",
    owner: "CRO/CISO",
    frequency: "Ongoing",
    technologyEnablers: "GRC",
    auditTestMethod: "Treatment review",
    commonGaps: "Risks accepted without documentation; No escalation",
    severity: "Medium",
    automationPotential: "Medium",
  },
  {
    controlId: "RBI-RISK-04",
    controlDomain: "IT Risk Management",
    controlRequirement: "Key Risk Indicators (KRIs) for cyber risk",
    minimumImplementationStandard:
      "Defined KRIs with thresholds and escalation triggers",
    evidenceArtifacts: "KRI dashboard, Threshold breach reports",
    owner: "CISO",
    frequency: "Monthly",
    technologyEnablers: "GRC, SIEM",
    auditTestMethod: "KRI review",
    commonGaps: "No KRIs defined; No thresholds",
    severity: "Medium",
    automationPotential: "High",
  },
  {
    controlId: "RBI-RISK-05",
    controlDomain: "IT Risk Management",
    controlRequirement: "Risk reporting to Board",
    minimumImplementationStandard:
      "Quarterly cyber risk report to Board with trend analysis",
    evidenceArtifacts: "Board reports, Risk dashboards",
    owner: "CISO",
    frequency: "Quarterly",
    technologyEnablers: "GRC, BI tools",
    auditTestMethod: "Report review",
    commonGaps: "Infrequent reporting; No trend analysis",
    severity: "High",
    automationPotential: "Medium",
  },
  {
    controlId: "RBI-RISK-06",
    controlDomain: "IT Risk Management",
    controlRequirement: "Emerging threat monitoring",
    minimumImplementationStandard:
      "Process to monitor and assess emerging cyber threats",
    evidenceArtifacts: "Threat intelligence feeds, Assessment reports",
    owner: "CISO",
    frequency: "Ongoing",
    technologyEnablers: "Threat intel platforms",
    auditTestMethod: "Process review",
    commonGaps: "Reactive only; No formal process",
    severity: "Medium",
    automationPotential: "High",
  },
  {
    controlId: "RBI-AST-01",
    controlDomain: "Asset Management",
    controlRequirement: "Comprehensive IT asset inventory",
    minimumImplementationStandard:
      "Inventory of all hardware, software, and information assets with ownership",
    evidenceArtifacts: "Asset register, CMDB",
    owner: "IT Head",
    frequency: "Continuous",
    technologyEnablers: "CMDB (ServiceNow, BMC)",
    auditTestMethod: "Inventory audit",
    commonGaps: "Incomplete inventory; No ownership assigned",
    severity: "High",
    automationPotential: "High",
  },
  {
    controlId: "RBI-AST-02",
    controlDomain: "Asset Management",
    controlRequirement: "Asset classification scheme",
    minimumImplementationStandard:
      "Classification based on criticality and sensitivity (e.g., Critical, High, Medium, Low)",
    evidenceArtifacts: "Classification policy, Classified asset register",
    owner: "IT Head",
    frequency: "Annual review",
    technologyEnablers: "CMDB, DLP",
    auditTestMethod: "Classification review",
    commonGaps: "No classification; Inconsistent application",
    severity: "High",
    automationPotential: "Medium",
  },
  {
    controlId: "RBI-AST-03",
    controlDomain: "Asset Management",
    controlRequirement: "Critical asset identification",
    minimumImplementationStandard:
      "Documented list of critical assets with business justification",
    evidenceArtifacts: "Critical asset register, BIA linkage",
    owner: "IT Head/BCP",
    frequency: "Annual",
    technologyEnablers: "CMDB",
    auditTestMethod: "Critical asset review",
    commonGaps: "No critical designation; No BIA linkage",
    severity: "High",
    automationPotential: "Medium",
  },
  {
    controlId: "RBI-AST-04",
    controlDomain: "Asset Management",
    controlRequirement: "Asset lifecycle management",
    minimumImplementationStandard:
      "Processes for asset acquisition, deployment, maintenance, and disposal",
    evidenceArtifacts: "Lifecycle procedures, Disposal certificates",
    owner: "IT Head",
    frequency: "Ongoing",
    technologyEnablers: "ITAM tools",
    auditTestMethod: "Process review",
    commonGaps: "No disposal process; Assets untracked post-deployment",
    severity: "Medium",
    automationPotential: "Medium",
  },
  {
    controlId: "RBI-AST-05",
    controlDomain: "Asset Management",
    controlRequirement: "Software license management",
    minimumImplementationStandard:
      "Inventory of all software with license compliance tracking",
    evidenceArtifacts: "License register, Compliance reports",
    owner: "IT Head",
    frequency: "Quarterly",
    technologyEnablers: "SAM tools",
    auditTestMethod: "License audit",
    commonGaps: "Unlicensed software; Over/under licensing",
    severity: "Medium",
    automationPotential: "High",
  },
  {
    controlId: "RBI-AST-06",
    controlDomain: "Asset Management",
    controlRequirement: "Removable media controls",
    minimumImplementationStandard:
      "Policy and controls for removable media (USB, external drives)",
    evidenceArtifacts: "Media policy, DLP configuration",
    owner: "IT Head",
    frequency: "Ongoing",
    technologyEnablers: "DLP, Endpoint protection",
    auditTestMethod: "Control testing",
    commonGaps: "No USB restrictions; Policy not enforced",
    severity: "High",
    automationPotential: "High",
  },
  {
    controlId: "RBI-AST-07",
    controlDomain: "Asset Management",
    controlRequirement: "Asset disposal and sanitization",
    minimumImplementationStandard:
      "Secure disposal with data sanitization and certificate of destruction",
    evidenceArtifacts: "Disposal procedure, Destruction certificates",
    owner: "IT Head",
    frequency: "Per disposal",
    technologyEnablers: "-",
    auditTestMethod: "Disposal records review",
    commonGaps: "No sanitization; No destruction certificates",
    severity: "High",
    automationPotential: "Low",
  },
  {
    controlId: "RBI-IAM-01",
    controlDomain: "IAM & PAM",
    controlRequirement: "Unique identification for all users",
    minimumImplementationStandard:
      "Every user has unique ID; No shared accounts; Service accounts documented",
    evidenceArtifacts: "User ID database, Service account register",
    owner: "IT Head",
    frequency: "Continuous",
    technologyEnablers: "IAM (SailPoint, Saviynt), AD/LDAP",
    auditTestMethod: "User listing review, Shared account detection",
    commonGaps:
      "Shared accounts for legacy apps; Undocumented service accounts",
    severity: "High",
    automationPotential: "High",
  },
  {
    controlId: "RBI-IAM-02",
    controlDomain: "IAM & PAM",
    controlRequirement: "Multi-factor authentication for privileged and remote access",
    minimumImplementationStandard:
      "MFA mandatory for all admin access, VPN, and customer-facing portals",
    evidenceArtifacts: "MFA configuration, Penetration test results",
    owner: "IAM Lead",
    frequency: "Continuous",
    technologyEnablers: "Okta, Duo, RSA, Microsoft Auth",
    auditTestMethod: "Technical testing, Config review",
    commonGaps: "MFA not enforced for all privileged; SMS-only MFA",
    severity: "Critical",
    automationPotential: "High",
  },
  {
    controlId: "RBI-IAM-03",
    controlDomain: "IAM & PAM",
    controlRequirement: "Privileged Access Management implementation",
    minimumImplementationStandard:
      "PAM solution with password vaulting, session recording, JIT access",
    evidenceArtifacts: "PAM architecture, Session logs, Rotation reports",
    owner: "IAM Lead",
    frequency: "Continuous",
    technologyEnablers: "CyberArk, BeyondTrust, Thycotic",
    auditTestMethod: "PAM console review, Session sampling",
    commonGaps: "PAM limited to Windows; No session recording",
    severity: "Critical",
    automationPotential: "High",
  },
  {
    controlId: "RBI-IAM-04",
    controlDomain: "IAM & PAM",
    controlRequirement: "Role-based access control (RBAC)",
    minimumImplementationStandard:
      "Access granted based on job roles with documented role definitions",
    evidenceArtifacts: "Role matrix, Access mapping",
    owner: "IAM Lead",
    frequency: "Ongoing",
    technologyEnablers: "IAM, IGA platforms",
    auditTestMethod: "Role review, Access sampling",
    commonGaps: "Generic roles; No role documentation",
    severity: "High",
    automationPotential: "High",
  },
  {
    controlId: "RBI-IAM-05",
    controlDomain: "IAM & PAM",
    controlRequirement: "Periodic access review and recertification",
    minimumImplementationStandard:
      "Quarterly access reviews for privileged, semi-annual for standard",
    evidenceArtifacts: "Access review reports, Recertification evidence",
    owner: "IAM Lead",
    frequency: "Quarterly/Semi-annual",
    technologyEnablers: "IGA (SailPoint, Saviynt)",
    auditTestMethod: "Review records",
    commonGaps: "No access reviews; Incomplete coverage",
    severity: "High",
    automationPotential: "High",
  },
  {
    controlId: "RBI-IAM-06",
    controlDomain: "IAM & PAM",
    controlRequirement: "Segregation of duties (SoD) enforcement",
    minimumImplementationStandard:
      "SoD rules defined and enforced for conflicting access combinations",
    evidenceArtifacts: "SoD matrix, Violation reports",
    owner: "IAM Lead",
    frequency: "Ongoing",
    technologyEnablers: "IGA, GRC",
    auditTestMethod: "SoD testing",
    commonGaps: "No SoD rules; Violations not tracked",
    severity: "High",
    automationPotential: "High",
  },
  {
    controlId: "RBI-IAM-07",
    controlDomain: "IAM & PAM",
    controlRequirement: "Timely access revocation for leavers",
    minimumImplementationStandard:
      "Access revoked within 24 hours of separation; Same-day for privileged",
    evidenceArtifacts: "Offboarding process, Revocation logs",
    owner: "HR/IT",
    frequency: "Per event",
    technologyEnablers: "IAM, HR integration",
    auditTestMethod: "Leaver testing",
    commonGaps: "Delayed revocation; Orphaned accounts",
    severity: "Critical",
    automationPotential: "High",
  },
  {
    controlId: "RBI-IAM-08",
    controlDomain: "IAM & PAM",
    controlRequirement: "Password policy compliance",
    minimumImplementationStandard:
      "Complex passwords, minimum 12 characters, 90-day rotation, history enforcement",
    evidenceArtifacts: "Password policy, AD configuration",
    owner: "IT Head",
    frequency: "Ongoing",
    technologyEnablers: "AD, IAM",
    auditTestMethod: "Policy testing",
    commonGaps: "Weak passwords; No rotation enforcement",
    severity: "High",
    automationPotential: "High",
  },
  {
    controlId: "RBI-IAM-09",
    controlDomain: "IAM & PAM",
    controlRequirement: "Service account management",
    minimumImplementationStandard:
      "Service accounts inventoried, owned, reviewed, with password rotation",
    evidenceArtifacts: "Service account register, Ownership matrix",
    owner: "IT Head",
    frequency: "Quarterly",
    technologyEnablers: "PAM, IAM",
    auditTestMethod: "Service account audit",
    commonGaps: "Undocumented service accounts; No rotation",
    severity: "High",
    automationPotential: "High",
  },
  {
    controlId: "RBI-IAM-10",
    controlDomain: "IAM & PAM",
    controlRequirement: "Remote access controls",
    minimumImplementationStandard:
      "Secure remote access through VPN with MFA, session timeout, logging",
    evidenceArtifacts: "VPN configuration, Access logs",
    owner: "Network Lead",
    frequency: "Ongoing",
    technologyEnablers: "VPN, MFA",
    auditTestMethod: "Remote access testing",
    commonGaps: "Split tunneling enabled; No timeout",
    severity: "High",
    automationPotential: "High",
  },
  {
    controlId: "RBI-IAM-11",
    controlDomain: "IAM & PAM",
    controlRequirement: "Admin access to production systems",
    minimumImplementationStandard:
      "Restricted admin access with approval workflow and audit trail",
    evidenceArtifacts: "Admin access matrix, Approval workflow",
    owner: "IT Head",
    frequency: "Ongoing",
    technologyEnablers: "PAM, Ticketing",
    auditTestMethod: "Admin access review",
    commonGaps: "Direct admin access; No approval",
    severity: "Critical",
    automationPotential: "High",
  },
  {
    controlId: "RBI-IAM-12",
    controlDomain: "IAM & PAM",
    controlRequirement: "Database access controls",
    minimumImplementationStandard:
      "Named accounts for DB access with activity logging and DBA monitoring",
    evidenceArtifacts: "DB access matrix, Activity logs",
    owner: "DBA Lead",
    frequency: "Ongoing",
    technologyEnablers: "Database Activity Monitoring",
    auditTestMethod: "DB access review",
    commonGaps: "Generic DBA accounts; No logging",
    severity: "High",
    automationPotential: "High",
  },
  {
    controlId: "RBI-NET-01",
    controlDomain: "Network Security",
    controlRequirement: "Network segmentation",
    minimumImplementationStandard:
      "VLAN/firewall segmentation isolating core banking, internet, DMZ, internal",
    evidenceArtifacts: "Network architecture, Firewall rules",
    owner: "Network Lead",
    frequency: "Annual review",
    technologyEnablers: "Firewall, SDN",
    auditTestMethod: "Architecture review, Pen test",
    commonGaps: "Flat network; Inadequate DMZ",
    severity: "Critical",
    automationPotential: "High",
  },
  {
    controlId: "RBI-END-01",
    controlDomain: "Endpoint Security",
    controlRequirement: "Endpoint protection platform",
    minimumImplementationStandard:
      "EPP/EDR on all endpoints with centralized management",
    evidenceArtifacts: "EPP architecture, Coverage reports",
    owner: "IT Head",
    frequency: "Continuous",
    technologyEnablers: "EDR (CrowdStrike, SentinelOne, MDE)",
    auditTestMethod: "Coverage audit",
    commonGaps: "Incomplete coverage; AV only",
    severity: "Critical",
    automationPotential: "High",
  },
  {
    controlId: "RBI-VUL-01",
    controlDomain: "Vulnerability Management",
    controlRequirement: "Vulnerability assessment program",
    minimumImplementationStandard:
      "Quarterly VA of all internet-facing and critical internal systems",
    evidenceArtifacts: "VA policy, Scan reports",
    owner: "Security Lead",
    frequency: "Quarterly",
    technologyEnablers: "VA tools (Qualys, Tenable, Rapid7)",
    auditTestMethod: "VA scope review",
    commonGaps: "Annual only; Limited scope",
    severity: "High",
    automationPotential: "High",
  },
  {
    controlId: "RBI-APP-01",
    controlDomain: "Application Security",
    controlRequirement: "Secure SDLC implementation",
    minimumImplementationStandard:
      "Security integrated in SDLC with security requirements, design review, testing",
    evidenceArtifacts: "SDLC procedure, Security gates",
    owner: "Dev Lead",
    frequency: "Per release",
    technologyEnablers: "SAST, DAST",
    auditTestMethod: "SDLC audit",
    commonGaps: "No security in SDLC",
    severity: "High",
    automationPotential: "Medium",
  },
  {
    controlId: "RBI-DAT-01",
    controlDomain: "Data Security",
    controlRequirement: "Data classification",
    minimumImplementationStandard:
      "4-tier classification (Public, Internal, Confidential, Restricted) with handling procedures",
    evidenceArtifacts: "Classification policy, Labeled data",
    owner: "Data Owner",
    frequency: "Annual review",
    technologyEnablers: "DLP, Classification tools",
    auditTestMethod: "Classification audit",
    commonGaps: "No classification",
    severity: "High",
    automationPotential: "Medium",
  },
  {
    controlId: "RBI-SOC-01",
    controlDomain: "SOC & Logging",
    controlRequirement: "24x7 Security Operations Center",
    minimumImplementationStandard:
      "SOC operational 24x7 with L1/L2/L3 structure, defined escalation",
    evidenceArtifacts: "SOC org, Shift rosters, Playbooks",
    owner: "SOC Manager",
    frequency: "Continuous",
    technologyEnablers: "SIEM, SOAR",
    auditTestMethod: "SOC observation",
    commonGaps: "8x5 SOC; No playbooks",
    severity: "Critical",
    automationPotential: "Medium",
  },
  {
    controlId: "RBI-INC-01",
    controlDomain: "Incident Response",
    controlRequirement: "Incident response plan",
    minimumImplementationStandard:
      "Documented IRP covering detection, classification, containment, eradication, recovery",
    evidenceArtifacts: "IRP document",
    owner: "CISO",
    frequency: "Annual review",
    technologyEnablers: "Incident management",
    auditTestMethod: "IRP walkthrough",
    commonGaps: "No documented IRP",
    severity: "Critical",
    automationPotential: "Low",
  },
  {
    controlId: "RBI-INC-02",
    controlDomain: "Incident Response",
    controlRequirement: "Incident classification",
    minimumImplementationStandard:
      "Classification matrix for incident severity and type",
    evidenceArtifacts: "Classification matrix",
    owner: "CISO",
    frequency: "Annual review",
    technologyEnablers: "-",
    auditTestMethod: "Classification review",
    commonGaps: "No classification criteria",
    severity: "High",
    automationPotential: "Medium",
  },
  {
    controlId: "RBI-INC-03",
    controlDomain: "Incident Response",
    controlRequirement: "RBI incident reporting",
    minimumImplementationStandard:
      "Process for reporting cyber incidents to RBI within 6 hours",
    evidenceArtifacts: "Reporting SOP, Portal access",
    owner: "CISO",
    frequency: "Per incident",
    technologyEnablers: "SOAR",
    auditTestMethod: "Reporting drill",
    commonGaps: "No clear process; Delays",
    severity: "Critical",
    automationPotential: "Medium",
  },
  {
    controlId: "RBI-INC-04",
    controlDomain: "Incident Response",
    controlRequirement: "Incident response team",
    minimumImplementationStandard:
      "Defined IR team with roles, responsibilities, and contact information",
    evidenceArtifacts: "IR team roster, RACI",
    owner: "CISO",
    frequency: "Annual review",
    technologyEnablers: "-",
    auditTestMethod: "Team review",
    commonGaps: "No defined team",
    severity: "High",
    automationPotential: "Low",
  },
  {
    controlId: "RBI-INC-05",
    controlDomain: "Incident Response",
    controlRequirement: "Incident drills and tabletops",
    minimumImplementationStandard:
      "Quarterly tabletop exercises with annual full-scale drill",
    evidenceArtifacts: "Drill reports, Lessons learned",
    owner: "CISO",
    frequency: "Quarterly",
    technologyEnablers: "-",
    auditTestMethod: "Drill observation",
    commonGaps: "No drills; Generic scenarios",
    severity: "High",
    automationPotential: "Low",
  },
  {
    controlId: "RBI-INC-06",
    controlDomain: "Incident Response",
    controlRequirement: "Forensic capability",
    minimumImplementationStandard:
      "Forensic investigation capability with evidence preservation",
    evidenceArtifacts: "Forensic tools, Procedures",
    owner: "CISO",
    frequency: "Per incident",
    technologyEnablers: "Forensic tools",
    auditTestMethod: "Forensic drill",
    commonGaps: "No forensic capability",
    severity: "High",
    automationPotential: "Low",
  },
  {
    controlId: "RBI-INC-07",
    controlDomain: "Incident Response",
    controlRequirement: "Post-incident review",
    minimumImplementationStandard:
      "Root cause analysis and lessons learned for all significant incidents",
    evidenceArtifacts: "PIR reports, Action tracking",
    owner: "CISO",
    frequency: "Per incident",
    technologyEnablers: "-",
    auditTestMethod: "PIR review",
    commonGaps: "No RCA; Lessons not tracked",
    severity: "Medium",
    automationPotential: "Low",
  },
  {
    controlId: "RBI-BCP-01",
    controlDomain: "BCP/DR",
    controlRequirement: "Business Impact Analysis",
    minimumImplementationStandard:
      "BIA for all critical business processes with RTO/RPO",
    evidenceArtifacts: "BIA document",
    owner: "BCP Lead",
    frequency: "Annual",
    technologyEnablers: "BCP tools",
    auditTestMethod: "BIA review",
    commonGaps: "No BIA; Generic RTOs",
    severity: "High",
    automationPotential: "Medium",
  },
  {
    controlId: "RBI-BCP-02",
    controlDomain: "BCP/DR",
    controlRequirement: "BCP and DR plans",
    minimumImplementationStandard:
      "Documented plans for business continuity and disaster recovery",
    evidenceArtifacts: "BCP/DR documents",
    owner: "BCP Lead",
    frequency: "Annual",
    technologyEnablers: "BCP tools",
    auditTestMethod: "Plan review",
    commonGaps: "Generic plans; Not tested",
    severity: "High",
    automationPotential: "Low",
  },
  {
    controlId: "RBI-BCP-03",
    controlDomain: "BCP/DR",
    controlRequirement: "DR site and infrastructure",
    minimumImplementationStandard:
      "Secondary site meeting RTO/RPO requirements",
    evidenceArtifacts: "DR architecture, Site evidence",
    owner: "IT Head",
    frequency: "Ongoing",
    technologyEnablers: "DR tools",
    auditTestMethod: "DR site assessment",
    commonGaps: "DR site capacity issues",
    severity: "High",
    automationPotential: "Medium",
  },
  {
    controlId: "RBI-BCP-04",
    controlDomain: "BCP/DR",
    controlRequirement: "Data replication",
    minimumImplementationStandard:
      "Real-time or near-real-time replication for critical data",
    evidenceArtifacts: "Replication architecture, Lag reports",
    owner: "IT Head",
    frequency: "Continuous",
    technologyEnablers: "Storage replication",
    auditTestMethod: "Replication testing",
    commonGaps: "High lag; Single-site backups",
    severity: "Critical",
    automationPotential: "High",
  },
  {
    controlId: "RBI-BCP-05",
    controlDomain: "BCP/DR",
    controlRequirement: "Annual DR drill",
    minimumImplementationStandard:
      "Full DR drill with RTO/RPO measurement and gap remediation",
    evidenceArtifacts: "DR drill reports, Recovery times",
    owner: "BCP Lead",
    frequency: "Annual",
    technologyEnablers: "DR orchestration",
    auditTestMethod: "DR drill observation",
    commonGaps: "Partial drill; RTO not met",
    severity: "High",
    automationPotential: "Medium",
  },
  {
    controlId: "RBI-BCP-06",
    controlDomain: "BCP/DR",
    controlRequirement: "Backup verification",
    minimumImplementationStandard:
      "Regular backup integrity verification and restore testing",
    evidenceArtifacts: "Backup reports, Restore test results",
    owner: "IT Head",
    frequency: "Monthly",
    technologyEnablers: "Backup tools",
    auditTestMethod: "Restore testing",
    commonGaps: "No restore testing",
    severity: "High",
    automationPotential: "High",
  },
  {
    controlId: "RBI-BCP-07",
    controlDomain: "BCP/DR",
    controlRequirement: "Alternate processing arrangements",
    minimumImplementationStandard:
      "Arrangements for alternate processing if primary site unavailable",
    evidenceArtifacts: "Alternate arrangements, Contracts",
    owner: "BCP Lead",
    frequency: "Annual review",
    technologyEnablers: "-",
    auditTestMethod: "Arrangement review",
    commonGaps: "No alternate arrangements",
    severity: "Medium",
    automationPotential: "Low",
  },
  {
    controlId: "RBI-BCP-08",
    controlDomain: "BCP/DR",
    controlRequirement: "Crisis communication",
    minimumImplementationStandard:
      "Crisis communication plan with stakeholder notification",
    evidenceArtifacts: "Communication plan, Contact lists",
    owner: "BCP Lead",
    frequency: "Annual review",
    technologyEnablers: "-",
    auditTestMethod: "Communication drill",
    commonGaps: "No communication plan",
    severity: "Medium",
    automationPotential: "Low",
  },
  {
    controlId: "RBI-TPR-01",
    controlDomain: "Third-Party Risk",
    controlRequirement: "Vendor risk assessment",
    minimumImplementationStandard:
      "Risk assessment for all vendors with system access or data handling",
    evidenceArtifacts: "Vendor register, Assessments",
    owner: "Vendor Manager",
    frequency: "Annual",
    technologyEnablers: "TPRM platform",
    auditTestMethod: "Assessment review",
    commonGaps: "No assessments; Incomplete register",
    severity: "High",
    automationPotential: "Medium",
  },
  {
    controlId: "RBI-TPR-02",
    controlDomain: "Third-Party Risk",
    controlRequirement: "Due diligence for critical vendors",
    minimumImplementationStandard:
      "Enhanced due diligence for critical/high-risk vendors",
    evidenceArtifacts: "Due diligence reports",
    owner: "Vendor Manager",
    frequency: "Pre-contract",
    technologyEnablers: "-",
    auditTestMethod: "DD review",
    commonGaps: "No enhanced DD",
    severity: "High",
    automationPotential: "Low",
  },
  {
    controlId: "RBI-TPR-03",
    controlDomain: "Third-Party Risk",
    controlRequirement: "Security requirements in contracts",
    minimumImplementationStandard:
      "Security clauses in all vendor contracts covering data protection, audit rights",
    evidenceArtifacts: "Contract templates, Sample contracts",
    owner: "Legal",
    frequency: "Per contract",
    technologyEnablers: "CLM",
    auditTestMethod: "Contract review",
    commonGaps: "No security clauses",
    severity: "High",
    automationPotential: "Low",
  },
  {
    controlId: "RBI-TPR-04",
    controlDomain: "Third-Party Risk",
    controlRequirement: "Vendor access controls",
    minimumImplementationStandard:
      "Segregated access for vendors with logging and monitoring",
    evidenceArtifacts: "Vendor access matrix, Logs",
    owner: "IT Head",
    frequency: "Ongoing",
    technologyEnablers: "PAM, IAM",
    auditTestMethod: "Vendor access audit",
    commonGaps: "Co-mingled access; No logging",
    severity: "High",
    automationPotential: "High",
  },
  {
    controlId: "RBI-TPR-05",
    controlDomain: "Third-Party Risk",
    controlRequirement: "Vendor security monitoring",
    minimumImplementationStandard:
      "Continuous monitoring of vendor security posture",
    evidenceArtifacts: "Security ratings, Monitoring reports",
    owner: "Vendor Manager",
    frequency: "Continuous",
    technologyEnablers:
      "Security ratings (BitSight, SecurityScorecard)",
    auditTestMethod: "Monitoring review",
    commonGaps: "No monitoring",
    severity: "Medium",
    automationPotential: "High",
  },
  {
    controlId: "RBI-TPR-06",
    controlDomain: "Third-Party Risk",
    controlRequirement: "Subcontractor oversight",
    minimumImplementationStandard:
      "Visibility and controls over vendor subcontractors",
    evidenceArtifacts: "Subcontractor register, Approvals",
    owner: "Vendor Manager",
    frequency: "Per contract",
    technologyEnablers: "-",
    auditTestMethod: "Subcontractor review",
    commonGaps: "No subcontractor visibility",
    severity: "Medium",
    automationPotential: "Low",
  },
  {
    controlId: "RBI-TPR-07",
    controlDomain: "Third-Party Risk",
    controlRequirement: "Vendor incident notification",
    minimumImplementationStandard:
      "Contractual requirement for vendor security incident notification",
    evidenceArtifacts: "Contract clauses, Notification process",
    owner: "Vendor Manager",
    frequency: "Per incident",
    technologyEnablers: "-",
    auditTestMethod: "Clause review",
    commonGaps: "No notification requirement",
    severity: "High",
    automationPotential: "Low",
  },
  {
    controlId: "RBI-TPR-08",
    controlDomain: "Third-Party Risk",
    controlRequirement: "Right to audit",
    minimumImplementationStandard:
      "Contractual right to audit vendor security controls",
    evidenceArtifacts: "Contract clauses, Audit reports",
    owner: "Vendor Manager",
    frequency: "Annual",
    technologyEnablers: "-",
    auditTestMethod: "Audit review",
    commonGaps: "No audit rights",
    severity: "Medium",
    automationPotential: "Low",
  },
  {
    controlId: "RBI-TPR-09",
    controlDomain: "Third-Party Risk",
    controlRequirement: "Vendor offboarding",
    minimumImplementationStandard:
      "Process for revoking vendor access and data return/destruction",
    evidenceArtifacts: "Offboarding process, Evidence",
    owner: "Vendor Manager",
    frequency: "Per termination",
    technologyEnablers: "IAM",
    auditTestMethod: "Offboarding review",
    commonGaps: "No offboarding process",
    severity: "High",
    automationPotential: "Medium",
  },
  {
    controlId: "RBI-FRD-01",
    controlDomain: "Fraud Prevention",
    controlRequirement: "Transaction monitoring",
    minimumImplementationStandard:
      "Real-time monitoring for fraudulent transactions",
    evidenceArtifacts: "Fraud monitoring architecture, Rules",
    owner: "Fraud Lead",
    frequency: "Continuous",
    technologyEnablers: "Fraud detection (NICE, SAS)",
    auditTestMethod: "Monitoring review",
    commonGaps: "Rule-based only; High false positives",
    severity: "High",
    automationPotential: "High",
  },
  {
    controlId: "RBI-FRD-02",
    controlDomain: "Fraud Prevention",
    controlRequirement: "Transaction velocity limits",
    minimumImplementationStandard:
      "Configurable limits on transaction volume and value",
    evidenceArtifacts: "Limit configuration, Override process",
    owner: "Business",
    frequency: "Ongoing",
    technologyEnablers: "Core banking, Fraud tools",
    auditTestMethod: "Limit testing",
    commonGaps: "No limits; Easy override",
    severity: "High",
    automationPotential: "High",
  },
  {
    controlId: "RBI-FRD-03",
    controlDomain: "Fraud Prevention",
    controlRequirement: "Customer authentication for transactions",
    minimumImplementationStandard:
      "Step-up authentication for high-risk transactions",
    evidenceArtifacts: "Authentication flow, Risk scoring",
    owner: "Business",
    frequency: "Ongoing",
    technologyEnablers: "MFA, Risk engine",
    auditTestMethod: "Authentication testing",
    commonGaps: "No step-up; Weak MFA",
    severity: "Critical",
    automationPotential: "High",
  },
  {
    controlId: "RBI-FRD-04",
    controlDomain: "Fraud Prevention",
    controlRequirement: "Fraud analytics and ML",
    minimumImplementationStandard:
      "ML-based fraud detection supplementing rule-based",
    evidenceArtifacts: "ML models, Detection metrics",
    owner: "Fraud Lead",
    frequency: "Ongoing",
    technologyEnablers: "ML platforms",
    auditTestMethod: "Model review",
    commonGaps: "No ML; Outdated rules",
    severity: "Medium",
    automationPotential: "High",
  },
  {
    controlId: "RBI-FRD-05",
    controlDomain: "Fraud Prevention",
    controlRequirement: "Fraud reporting and investigation",
    minimumImplementationStandard:
      "Process for fraud case management and investigation",
    evidenceArtifacts: "Case management, Investigation reports",
    owner: "Fraud Lead",
    frequency: "Per case",
    technologyEnablers: "Case management",
    auditTestMethod: "Case review",
    commonGaps: "Manual tracking",
    severity: "Medium",
    automationPotential: "Medium",
  },
  {
    controlId: "RBI-FRD-06",
    controlDomain: "Fraud Prevention",
    controlRequirement: "Customer fraud awareness",
    minimumImplementationStandard:
      "Customer communication on fraud prevention and safe practices",
    evidenceArtifacts: "Communication materials, Campaigns",
    owner: "Marketing",
    frequency: "Quarterly",
    technologyEnablers: "-",
    auditTestMethod: "Communication review",
    commonGaps: "No customer awareness",
    severity: "Medium",
    automationPotential: "Low",
  },
  {
    controlId: "RBI-CHN-01",
    controlDomain: "Channel Security",
    controlRequirement: "Internet banking security",
    minimumImplementationStandard:
      "Secure architecture for internet banking with WAF, encryption, session management",
    evidenceArtifacts: "IB architecture, Security config",
    owner: "Digital Lead",
    frequency: "Continuous",
    technologyEnablers: "WAF, TLS",
    auditTestMethod: "IB security assessment",
    commonGaps: "Weak session management",
    severity: "Critical",
    automationPotential: "High",
  },
  {
    controlId: "RBI-CHN-02",
    controlDomain: "Channel Security",
    controlRequirement: "Mobile banking security",
    minimumImplementationStandard:
      "Secure mobile app with certificate pinning, code obfuscation, runtime protection",
    evidenceArtifacts: "Mobile security config, RASP",
    owner: "Digital Lead",
    frequency: "Per release",
    technologyEnablers: "RASP, MAST",
    auditTestMethod: "Mobile app assessment",
    commonGaps: "No certificate pinning",
    severity: "Critical",
    automationPotential: "High",
  },
  {
    controlId: "RBI-CHN-03",
    controlDomain: "Channel Security",
    controlRequirement: "ATM security",
    minimumImplementationStandard:
      "Secure ATM infrastructure with hardening, whitelisting, network isolation",
    evidenceArtifacts: "ATM security config",
    owner: "ATM Lead",
    frequency: "Ongoing",
    technologyEnablers: "ATM security tools",
    auditTestMethod: "ATM assessment",
    commonGaps: "Generic Windows; No whitelisting",
    severity: "High",
    automationPotential: "High",
  },
  {
    controlId: "RBI-CHN-04",
    controlDomain: "Channel Security",
    controlRequirement: "POS and payment terminal security",
    minimumImplementationStandard:
      "PCI-compliant POS with P2PE, secure key injection",
    evidenceArtifacts: "POS security config, PCI evidence",
    owner: "Payment Lead",
    frequency: "Ongoing",
    technologyEnablers: "P2PE",
    auditTestMethod: "POS assessment",
    commonGaps: "Non-compliant terminals",
    severity: "High",
    automationPotential: "Medium",
  },
  {
    controlId: "RBI-CHN-05",
    controlDomain: "Channel Security",
    controlRequirement: "UPI and payment gateway security",
    minimumImplementationStandard:
      "Secure integration with UPI and payment gateways",
    evidenceArtifacts: "Integration security, API testing",
    owner: "Payment Lead",
    frequency: "Per integration",
    technologyEnablers: "API gateway",
    auditTestMethod: "API security testing",
    commonGaps: "Insecure API integration",
    severity: "High",
    automationPotential: "High",
  },
  {
    controlId: "RBI-CHN-06",
    controlDomain: "Channel Security",
    controlRequirement: "Contact center security",
    minimumImplementationStandard:
      "Secure contact center with call recording, agent authentication, PII masking",
    evidenceArtifacts: "CC security config",
    owner: "CC Lead",
    frequency: "Ongoing",
    technologyEnablers: "CC platforms",
    auditTestMethod: "CC assessment",
    commonGaps: "No PII masking; Weak auth",
    severity: "High",
    automationPotential: "Medium",
  },
  {
    controlId: "RBI-CHN-07",
    controlDomain: "Channel Security",
    controlRequirement: "Chatbot and AI security",
    minimumImplementationStandard:
      "Secure chatbot implementation with data handling controls",
    evidenceArtifacts: "Chatbot security, Data flow",
    owner: "Digital Lead",
    frequency: "Per release",
    technologyEnablers: "-",
    auditTestMethod: "Chatbot assessment",
    commonGaps: "Data leakage; No controls",
    severity: "Medium",
    automationPotential: "Medium",
  },
  {
    controlId: "RBI-CHN-08",
    controlDomain: "Channel Security",
    controlRequirement: "Branch network security",
    minimumImplementationStandard:
      "Secure branch connectivity and endpoint security",
    evidenceArtifacts: "Branch network architecture",
    owner: "Network Lead",
    frequency: "Ongoing",
    technologyEnablers: "SD-WAN, EPP",
    auditTestMethod: "Branch assessment",
    commonGaps: "Flat branch network",
    severity: "High",
    automationPotential: "High",
  },
];
export const RBI_DOMAIN_COUNTS_FROM_CONTROLS =
  RBI_CONTROLS.reduce((acc, c) => {
    acc[c.controlDomain] = (acc[c.controlDomain] ?? 0) + 1;
    return acc;
  }, {});

